import variables from '../variables';

const MuiAutocomplete = {
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: variables.input.backgroundColor,
        padding: 0,
        '& .MuiAutocomplete-input': {
          padding: '16.5px 14px',
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
    },
    paper: {
      ...variables.typography.body2,
      borderStyle: 'solid',
      borderWidth: variables.input.borderWidth,
      borderColor: variables.input.borderColorSelected,
      borderRadius: 0,
    },
    option: {
      '&.Mui-focused': {
        backgroundColor: variables.autoComplete.backgoundColorFocused,
        color: variables.autoComplete.colorFocused,
      },
    },
    listbox: {
      padding: 0,
      '& .MuiAutocomplete-option.Mui-focused': {
        backgroundColor: variables.autoComplete.backgoundColorFocused,
        color: variables.autoComplete.colorFocused,
      },
    },
  },
};

export default MuiAutocomplete;
